import React from "react";

export default function MSAccess_Right() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Right</h1>
      <p>This is the MSAccess_Right component generated from the SQL JSON.</p>
    </div>
  );
}
